import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { NgxTippyDirective, NgxTippyProps } from 'ngx-tippy-wrapper';
import { Instance, Props } from 'tippy.js';

interface TippyHTMLElement extends HTMLElement {
  _tippy: Instance;
}

@Directive({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  selector: '[ngxTippy][mdTippyVisible]',
})
export class TippyVisibleDirective implements OnInit, OnChanges, OnDestroy {
  @Input()
  mdTippyVisible = false;

  @Input()
  mdTippyProps?: NgxTippyProps;

  private readonly updateProps = () => {
    if ('_tippy' in this.el.nativeElement) {
      const tippy = (this.el.nativeElement as TippyHTMLElement)._tippy;
      tippy.setProps({
        ...this.mdTippyProps,
        showOnCreate: this.mdTippyVisible,
        interactive: true,
        hideOnClick: false,
        trigger: 'manual',
      } as Partial<Props>);
    }
  };

  constructor(
    private readonly el: ElementRef,
    private readonly ngxTippyDirective: NgxTippyDirective,
  ) {
    this.ngxTippyDirective.tippyProps = {
      showOnCreate: false,
      interactive: true,
      hideOnClick: false,
      trigger: 'manual',
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      ('mdTippyVisible' in changes || 'mdTippyProps' in changes) &&
      '_tippy' in this.el.nativeElement
    ) {
      this.updateProps();

      const tippy = (this.el.nativeElement as TippyHTMLElement)._tippy;

      if (this.mdTippyVisible) {
        tippy.show();
      } else {
        tippy.hide();
      }
    }
  }

  ngOnInit(): void {
    this.updateProps();
    const tippy = (this.el.nativeElement as TippyHTMLElement)._tippy;

    if (this.mdTippyVisible) {
      tippy.show();
    } else {
      tippy.hide();
    }
  }

  ngOnDestroy(): void {}
}
